// extracted by mini-css-extract-plugin
export default {"container":"header_container__AzWgZ","title":"header_title__j5wSX"};